import { createRouter } from '@tanstack/react-router';
import { routeTree } from '../routeTree.gen';
import { parseSearch, stringifySearch } from './run-url-codec';

/**
 * Singleton router instance.
 *
 * `routeTree` is generated by the @tanstack/router-plugin at dev + build time
 * from the contents of src/routes/. Do NOT edit routeTree.gen.ts by hand.
 *
 * Type-safety: the `Register` interface tells TanStack Router the exact shape
 * of routes — `<Link to="/foo">` becomes a compile-time error if `/foo`
 * doesn't exist.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // Keep the global sequential run id out of the address bar (see run-url-codec).
  // Only *_run_id search values are transformed; every other param is handed to
  // TanStack's default serializer untouched.
  parseSearch,
  stringifySearch,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
